var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logout_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.325 14.23c1.8-1.474 2.699-2.373 4.102-4.101C17.024 8.4 16.124 7.5 14.325 6.027M5.72 10.129h12.661",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.054 1.97a2.933 2.933 0 0 0-1.787-.756 57.107 57.107 0 0 0-4.05-.143c-1.383 0-2.736.05-4.05.143-1.446.103-2.553 1.181-2.618 2.494A126.88 126.88 0 0 0 1.395 10c0 2.159.053 4.264.154 6.292.065 1.313 1.172 2.391 2.618 2.494a57.07 57.07 0 0 0 4.05.143 57.07 57.07 0 0 0 4.05-.143 2.933 2.933 0 0 0 1.787-.756"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logout_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgLogout;